export default __webpack_public_path__ + "static/media/center.ca6a12d8.png";